import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  base: '',
  mode: 'history',
  routes: [

    {
      path: '/login',
      name: "login",
      component: () => import("@/views/Login.vue"),
      meta: {
        title: "登录 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    {
      path: '/register',
      name: "register",
      component: () => import("@/views/register.vue"),
      meta: {
        title: "注册 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    {
      path: "/",
      name: "home",
      component: () => import("@/views/my/index.vue"),
      roles: ["agent"],
      meta: {
        title: '首页'
      }
    },
    {
      path: "/index",
      name: "home",
      component: () => import("@/views/my/index.vue"),
      roles: ["agent"],
      meta: {
        title: '首页'
      }
    },
      
    {
      path: "/goods",
      name: "goods",
      component: () => import("@/views/home/goods.vue"),
      roles: ["agent"],
      meta: {
        title: '溯源详情'
      }
    }, {
      path: "/fw/:keyword",
      name: "fw",
      component: () => import("@/views/home/fw.vue"),
      roles: ["agent"],
      meta: {
        title: '溯源详情'
      }
    },    {
      path: "/order",
      name: "order",
      component: () => import("@/views/home/order.vue"),
      roles: ["agent"],
      meta: {
        title: '订单明细'
      }
    },
    {
      path: "/quit",
      name: "quit",
      component: () => import("@/views/home/quit.vue"),
      roles: ["agent"],
      meta: {
        title: '出货记录'
      }
    },
      {
      path: "/quitHe",
      name: "quitHe",
      component: () => import("@/views/home/quitHe.vue"),
      roles: ["agent"],
      meta: {
        title: '出货记录'
      }
    },
      {
      path: "/heChu",
      name: "retail",
      component: () => import("@/views/home/heChu.vue"),
      roles: ["agent"],
      meta: {
        title: '零售出货'
      }
    },
    {
      path: "/retail",
      name: "retail",
      component: () => import("@/views/home/retail.vue"),
      roles: ["agent"],
      meta: {
        title: '出货'
      }
    },
    // {
    //   path: "/retail1",
    //   name: "retail",
    //   component: () => import("@/views/my/retail/index.vue"),
    //   roles: ["agent"],
    //   meta: {
    //     title: '出货'
    //   }
    // },
    {
      path: "/scan",
      name: "scan",
      component: () => import("@/views/home/scan.vue"),
      roles: ["agent"],
      meta: {
        title: '扫码'
      }
    },
    {
      path: "/scan1",
      name: "scan",
      component: () => import("@/views/home/scan1.vue"),
      roles: ["agent"],
      meta: {
        title: '扫码'
      }
    },
    {
      path: "/scan2",
      name: "scan",
      component: () => import("@/views/home/scan2.vue"),
      roles: ["agent"],
      meta: {
        title: '扫码'
      }
    },
    {
      path: "/user/stock",
      name: "stock",
      component: () => import("@/views/user/stock.vue"),
      roles: ["agent"],
      meta: {
        title: '我的溯源'
      }
    },
    {
      path: "/user/msg",
      name: "msg",
      component: () => import("@/views/user/msg.vue"),
      roles: ["agent"],
      meta: {
        title: '消息中心'
      }
    },
    // 云仓库记录
    {
      path: "/stock",
      name: "stockIndex",
      component: () => import("@/views/stock/index.vue"),
      roles: ["agent"],
      meta: {
        title: "云仓"
      }
    },
    //  云仓库存明细
    {
      path: "/stock/detail",
      name: "stockDetail",
      component: () => import("@/views/stock/detail.vue"),
      roles: ["agent"],
      meta: {
        title: "云仓记录明细"
      }
    },
     // 本地仓库存明细
     {
      path: "/stock/local",
      name: "stockLocalIndex",
      component: () => import("@/views/stock/local/index.vue"),
      roles: ["agent"],
      meta: {
        title: "本地仓 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 下级升级申请详情
    {
      path: "/team/agent/level/detail",
      name: "levelDetail",
      component: () => import("@/views/team/agent/level/detail.vue"),
      roles: ["agent"],
      meta: {
        title: "下级升级申请"
      }
    },
    // // 下级降级申请详情
    // {
    //   path: "/team/agent/level/down/detail",
    //   name: "levelDownDetail",
    //   component: () => import("@/views/team/agent/level/down/detail.vue"),
    //   roles: ["agent"],
    //   meta: {
    //     title: "下级降级申请 - " + process.env.VUE_APP_WEB_TITLE
    //   }
    // },
    {
      path: "/user/level",
      name: "level",
      component: () => import("@/views/user/level.vue"),
      roles: ["agent"],
      meta: {
        title: '等级记录'
      }
    },
    {
      path: "/user/agentList",
      name: "agentList",
      component: () => import("@/views/user/agentList.vue"),
      roles: ["agent"],
      meta: {
        title: '我的通讯录'
      }
    },
    {
      path: "/user/tobeList",
      name: "tobeList",
      component: () => import("@/views/user/tobeList.vue"),
      roles: ["agent"],
      meta: {
        title: '我的邀新历史'
      }
    },
    {
      path: "/user/tobe",
      name: "tobe",
      component: () => import("@/views/user/tobe.vue"),
      roles: ["agent"],
      meta: {
        title: '我的邀新'
      }
    },
    {
      path: "/user/info",
      name: "info",
      component: () => import("@/views/user/info.vue"),
      roles: ["agent"],
      meta: {
        title: '个人信息'
      }
    },
    {
      path: "/user/password",
      name: "password",
      component: () => import("@/views/user/password.vue"),
      roles: ["agent"],
      meta: {
        title: '修改密码'
      }
    },
    {
      path: "/order/list",
      name: "orderList",
      component: () => import("@/views/order/list.vue"),
      roles: ["agent"],
      meta: {
        title: '溯源记录'
      }
    },
    // 补货
    {
      path: "/order/recharge",
      name: "orderRecharge",
      component: () => import("@/views/order/recharge.vue"),
      roles: ["agent"],
      meta: {
        title: "发起补货 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
        // 我发起补货订单列表
        {
          path: "/order/my/recharge",
          name: "myRechargeList",
          component: () => import("@/views/order/my/recharge/index.vue"),
          roles: ["agent"],
          meta: {
            title: "我的补货 - " + process.env.VUE_APP_WEB_TITLE
          }
        },
         // 我发起补货详情
    {
      path: "/order/my/recharge/detail",
      name: "myRechargeDetail",
      component: () => import("@/views/order/my/recharge/detail.vue"),
      roles: ["agent"],
      meta: {
        title: "我的补货详情 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 我的补货订单流转记录
    // {
    //   path: "/order/my/recharge/audit_record",
    //   name: "myRechargeRecord",
    //   component: () => import("@/views/order/my/recharge/audit_record.vue"),
    //   roles: ["agent"],
    //   meta: {
    //     title: "我的补货流转记录 - " + process.env.VUE_APP_WEB_TITLE
    //   }
    // },
    // 我的提货订单列表
    {
      path: "/order/my",
      name: "myOrderList",
      component: () => import("@/views/order/my/index.vue"),
      roles: ["agent"],
      meta: {
        title: "我的提货 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 我的提货详情
    {
      path: "/order/my/detail",
      name: "myOrderDetail",
      component: () => import("@/views/order/my/detail.vue"),
      roles: ["agent"],
      meta: {
        title: "我的提货详情 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
     // 下级补货订单列表
     {
      path: "/order/sub/recharge",
      name: "subRechargeList",
      component: () => import("@/views/order/sub/recharge/index.vue"),
      roles: ["agent"],
      meta: {
        title: "下级补货单 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 下级补货订单详情
    {
      path: "/order/sub/recharge/detail",
      name: "subRechargeList",
      component: () => import("@/views/order/sub/recharge/detail.vue"),
      roles: ["agent"],
      meta: {
        title: "补货订单详情 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
      //退出经销商申请
      {
        path: "/my/quit",
        name: "applyQuit",
        component: () => import("@/views/my/quit/upgrade.vue"),
        roles: ["agent"],
        meta: {
          title: " 退出经销商- " + process.env.VUE_APP_WEB_TITLE
        }
      },
      // 下级退出审核
    {
      path: "/team/agent/quit",
      name: "auditQuitList",
      component: () => import("@/views/team/agent/quit/index.vue"),
      roles: ["agent"],
      meta: {
        title: "退出审核 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 退出审核详情
    {
      path: "/team/agent/quit/detail",
      name: "auditQuitDetail",
      component: () => import("@/views/team/agent/quit/detail.vue"),
      roles: ["agent"],
      meta: {
        title: "退出审核详情 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // // 我的提货订单流转记录
    // {
    //   path: "/order/my/audit_record",
    //   name: "myOrderRecord",
    //   component: () => import("@/views/order/my/audit_record.vue"),
    //   roles: ["agent"],
    //   meta: {
    //     title: "我的提货流转记录 - " + process.env.VUE_APP_WEB_TITLE
    //   }
    // },
    {
      path: "/order/add",
      name: "orderAdd",
      component: () => import("@/views/order/add.vue"),
      roles: ["agent"],
      meta: {
        title: '新建订单'
      }
    },
    // 选择地址
    {
      path: "/order/address",
      name: "Address",
      component: () => import("@/views/order/address.vue"),
      roles: ["agent"],
      meta: {
        title: "选择地址 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 新增地址
    {
      path: "/order/address/add",
      name: "addAddress",
      component: () => import("@/views/order/addAddress.vue"),
      roles: ["agent"],
      meta: {
        title: "地址编辑"
      }
    },
 
    // 下级升类别审核列表
    {
      path: "/team/agent/level",
      name: "levelList",
      component: () => import("@/views/team/agent/level/list.vue"),
      roles: ["agent"],
      meta: {
        title: "下级升类别审核 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 下级保证金处理
    {
      path: "/team/agent/deposit",
      name: "auditDepositList",
      component: () => import("@/views/team/agent/deposit/index.vue"),
      roles: ["agent"],
      meta: {
        title: "保证金处理 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 邀请意向
    {
      path: "/team/agent/tobe/add",
      name: "agentAdd",
      component: () => import("@/views/team/agent/tobe/add.vue"),
      roles: ["agent"],
      meta: {
        title: "添加经销商 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 意向邀请分享链接
    {
      path: "/team/agent/tobe/share/:randCode",
      name: "agentTobeShare",
      component: () => import("@/views/team/agent/tobe/share.vue"),
      roles: ["agent"],
      meta: {
        title: "邀请码 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 意向邀请分享链接
    {
      path: "/team/agent/tobe/asd/:randCode",
      name: "agentTobeShare",
      component: () => import("@/views/team/agent/tobe/asd.vue"),
      roles: ["agent"],
      meta: {
        title: "邀请码 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    // 我的资料
    {
      path: "/my/userinfo",
      name: "userinfo",
      component: () => import("@/views/my/userinfo/index.vue"),
      roles: ["agent"],
      meta: {
        title: "基本资料" 
      }
    },
     //我要升类别
     {
      path: "/my/level/upgrade",
      name: "applyUpgrade",
      component: () => import("@/views/my/level/upgrade.vue"),
      roles: ["agent"],
      meta: {
        title: " 我要升类别" 
      }
    },
     //主动降级申请
     {
      path: "/my/level/down/apply",
      name: "downApply",
      component: () => import("@/views/my/level/down/apply.vue"),
      roles: ["agent"],
      meta: {
        title: " 降级申请" 
      }
    },
     //等级类别
     {
      path: "/my/level",
      name: "myLevel",
      component: () => import("@/views/my/level/index.vue"),
      roles: ["agent"],
      meta: {
        title: " 我的类别类别"
      }
    },
    //我的保证金
    {
      path: "/my/deposit",
      name: "myDeposit",
      component: () => import("@/views/my/deposit/index.vue"),
      roles: ["agent"],
      meta: {
        title: " 我的保证金"
      }
    },
      //我的保证金
      {
        path: "/my/auth",
        name: "myDeposit",
        component: () => import("@/views/my/auth.vue"),
        roles: ["agent"],
        meta: {
          title: "授权证书"
        }
      },
          //微信绑定列表
          {
            path: "/wx/list",
            name: "wxList",
            component: () => import("@/views/wx/list.vue"),
            roles: ["agent"],
            meta: {
              title: "微信绑定列表"
            }
          },
            //微信异常页面
            {
              path: "/wx/error",
              name: "wxerror",
              component: () => import("@/views/wx/error.vue"),
              roles: ["agent"],
              meta: {
                title: "微信绑定列表"
              }
            },
        //修改密码
        {
          path: "/my/pass",
          name: "myDeposit",
          component: () => import("@/views/my/pass.vue"),
          roles: ["agent"],
          meta: {
            title: "修改密码"
          }
        },
          //完善信息
          {
            path: "/my/edit",
            name: "myEdit",
            component: () => import("@/views/my/edit.vue"),
            roles: ["agent"],
            meta: {
              title: "修改密码"
            }
          },
          // 查看经销商详情
    {
      path: "/team/agent/detail",
      name: "agentDetail",
      component: () => import("@/views/team/agent/detail.vue"),
      roles: ["agent"],
      meta: {
        title: "经销商详情 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    
    {
      path: "/quitRetail",
      name: "quitRetail",
      component: () => import("@/views/home/quitRetail.vue"),
      roles: ["agent"],
      meta: {
        title: "批量转移 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    {
      path: "/stockQuit",
      name: "quitRetail",
      component: () => import("@/views/user/stockQuit.vue"),
      roles: ["stockQuit"],
      meta: {
        title: "产品出库 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/views/my/error.vue"),
      roles: ["stockQuit"],
      meta: {
        title: "产品出库 - " + process.env.VUE_APP_WEB_TITLE
      }
    },
    
        
       // 经销商搜索列表
      //  {
      //   path: "/team/agent/search",
      //   name: "searchAgent",
      //   component: () => import("@/views/team/agent/search.vue"),
      //   roles: ["agent"],
      //   meta: {
      //     title: "经销商搜索 - " + process.env.VUE_APP_WEB_TITLE
      //   }
      // },
      {
        path: "*",
        name: "errpage",
        component: () => import("@/views/Errpage.vue"),
        meta: {
          title: "页面走丢啦 - " + process.env.VUE_APP_WEB_TITLE
        }
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js